<template>
    <el-container>
        <div style="text-align: center;width: 100%;height: 100%">
            <el-image :src="imageUrl" :style="{ height: 'calc(100vh - 0px)' }"></el-image>
        </div>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            imageUrl:require('../../assets/indibamb.png'),
        }
    },
    created() {
    }
}
</script>


// WEBPACK FOOTER //
// src/page/scqjmb/jmb.vue